import { withRouter } from "react-router-dom";
import { NewTtnComponent } from "./new-ttn.component";
import { connect } from 'react-redux'
import { UkrposhtaModule } from "@components/modules/ukrposhta";
import { Orders } from "@components/orders";
import withStyles from '@material-ui/core/styles/withStyles';
import styles from './styles';
import form from '@style/form';
import modal from '@style/modal';
import combineStyles from '~/utils/styles';

const mapStateToProps = (state, props) => ({

});

const actions = {
    createTtn: UkrposhtaModule.actions.createTtn,
    getClients: UkrposhtaModule.actions.getClients,
    getCities: UkrposhtaModule.actions.getCities,
    createTTN: UkrposhtaModule.actions.createTTN,
    getOrderDetails: Orders.actions.getOrderDetails,
};

export const NewTtnContainer = connect(mapStateToProps, actions)((withRouter(withStyles(combineStyles(modal, form, styles))(NewTtnComponent))));
